exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dark .vehicles .deleted {\n  text-decoration: line-through;\n  background: rebeccapurple;\n  color: #e0c5c5;\n}\n.dark .vehicles .archived {\n  background: rebeccapurple;\n  color: #e0c5c5;\n}\n.vehicles .deleted {\n  text-decoration: line-through;\n  background: rebeccapurple;\n  color: #e0c5c5;\n}\n.vehicles .archived {\n  background: rebeccapurple;\n  color: #e0c5c5;\n}\n.search.x-row {\n  align-items: flex-start;\n}\n.has-more {\n  color: red;\n  font-weight: 700;\n}\n", ""]);

// exports
